import {
  headerOurServicesButton,
  membershipCorporateButton,
  membershipIndividualButton,
  membershipLoginButton,
  ourServicesArsaDunyasiButton,
  ourServicesEmlakYatirimUzmaniButton,
  // ourServicesJettasinButton,
  ourServicesProjeRadariButton,
} from "@/constants/test-selector-ids";

export default {
  ourServices: {
    name: "Hizmetlerimiz",
    url: "hizmetlerimiz",
    testSelector: headerOurServicesButton,
    child: [
      {
        name: "Arsa Dünyası",
        url: "arsa",
        id: "land",
        event: "hizmetlerimiz||arsa-dunyasi",
        testSelector: ourServicesArsaDunyasiButton,
      },
      {
        name: "Proje Radarı",
        url: "proje-radari",
        id: "project-radar",
        event: "hizmetlerimiz||proje-radari",
        testSelector: ourServicesProjeRadariButton,
      },
      {
        name: "Emlak Yatırım Uzmanı",
        url: "emlak-yatirim-uzmani",
        id: "real_estate_investment_specialist",
        event: "hizmetlerimiz||emlak-yatirim-uzmani",
        testSelector: ourServicesEmlakYatirimUzmaniButton,
      },
      // {
      //   name: "Jettaşın",
      //   url: "jettasin/",
      //   id: "jettasin",
      //   event: "hizmetlerimiz||jettasin",
      //   testSelector: ourServicesJettasinButton,
      // },
    ],
  },
  subscription: {
    name: "Üyelik",
    url: "uyelik",
    child: [
      {
        name: "Giriş Yap",
        url: "giris",
        id: "sign_in",
        event: "uyelik||giris-yap",
        testSelector: membershipLoginButton,
      },
      {
        name: "Bireysel Üyelik",
        url: "uye-ol/bireysel",
        id: "sign_up_individual",
        event: "uyelik||bireysel-uyelik",
        testSelector: membershipIndividualButton,
      },
      {
        name: "Kurumsal Üyelik",
        url: "uye-ol/kurumsal",
        id: "sign_up_corporate",
        event: "uyelik||kurumsal-uyelik",
        testSelector: membershipCorporateButton,
      },
    ],
  },
  authUser: {
    name: "",
    url: "",
    child: [
      {
        name: "İlan Ver",
        url: "ilanlarim/yeni-ilan-ekle",
        id: "post_an_ad",
        event: "profil||ilan-ver",
      },
      {
        name: "İlanlarım",
        url: "ilanlarim/aktif-ilanlarim",
        id: "my_ads",
        event: "profil||ilanlarim",
      },
      {
        name: "Kayıtlı Aramalarım",
        url: "kayitli-aramalarim",
        id: "saved_searches",
        event: "profil||kayitli-aramalarim",
      },
      {
        name: "Favori Listelerim",
        url: "favori-listelerim",
        id: "favorite_lists",
        event: "profil||favori-listelerim",
      },
      {
        name: "Mesajlarım",
        url: "mesajlarim",
        id: "messages",
        event: "profil||mesajlarim",
      },
      {
        name: "Üyelik",
        url: "uyeligim/uyelik-bilgileri",
        id: "membership",
        event: "profil||uyelik",
      },
      {
        name: "Çıkış Yap",
        url: "",
        id: "log_out",
        event: "profil||cikis-yap",
      },
    ],
  },
};

export const headerDisabledRoutes = [
  "/kibris-yatirim-firsatlari",
  "/proje-radari",
  "/yapi-kredi-avans-firsati/",
  "/akbank-avans-firsati/",
];

export const footerDisabledRoutes = ["/yapi-kredi-avans-firsati/", "/akbank-avans-firsati/"];
